import { render } from "./UploadAttendants.vue?vue&type=template&id=27f20512&scoped=true"
import script from "./UploadAttendants.vue?vue&type=script&lang=js"
export * from "./UploadAttendants.vue?vue&type=script&lang=js"

import "./UploadAttendants.vue?vue&type=style&index=0&id=27f20512&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f20512"]])

export default __exports__